import { NgModule } from '@angular/core';
import { TranslationPipe } from './translation/pipe/translation.pipe';
import { StoreModule } from '@ngrx/store';
import { reducer } from './translation/state/translate.reducer';

@NgModule({
  declarations: [
    TranslationPipe
  ],
  imports: [
    StoreModule.forFeature('translate', reducer)
  ],
  exports: [
    TranslationPipe
  ],
  providers: [
  ]
})
export class DopCoreModule { }
